import {
  SEMI_MAJOR_AXIS,
  SQUARED_ECCENTRICITY} from "@/utils/WGS84Util";
import Location from "./Location";

export const getMovement = (fromLoocation, toLocation) => {
  const latDiff =
    ((toLocation.latitude - fromLoocation.latitude) * Math.PI) / 180.0;
  const lngDiff =
    ((toLocation.longitude - fromLoocation.longitude) * Math.PI) / 180.0;
  const midLat =
    ((fromLoocation.latitude + toLocation.latitude) * Math.PI) / 360.0;
  const capW = Math.sqrt(
    1.0 - SQUARED_ECCENTRICITY * Math.pow(Math.sin(midLat), 2)
  );
  const capM =
    (SEMI_MAJOR_AXIS * (1.0 - SQUARED_ECCENTRICITY)) / Math.pow(capW, 3.0);
  const capN = SEMI_MAJOR_AXIS / capW;

  const t1 = capM * latDiff;
  const t2 = capN * Math.cos(midLat) * lngDiff;
  const distance = Math.sqrt(Math.pow(t1, 2.0) + Math.pow(t2, 2.0));

  const moveLngDiff =
    lngDiff < -Math.PI
      ? lngDiff + 2 * Math.PI
      : lngDiff > Math.PI
      ? lngDiff - 2 * Math.PI
      : lngDiff;
  const moveParallel = moveLngDiff * capN * Math.cos(midLat);
  const moveMeridian = latDiff * capM;
  const startAngle = (Math.atan2(moveMeridian, moveParallel) * 180.0) / Math.PI;
  let startDir = 90.0 - startAngle;
  if (startDir < 0) {
    startDir += 360.0;
  }

  return {
    distance: distance,
    direction: startDir,
    endDirection: startDir
  };
};

export const getArrivalPoint = (location, direction, distanceInMeter) => {
  const moveParallel =
    distanceInMeter * Math.sin((direction * Math.PI) / 180.0);
  const moveMeridian =
    distanceInMeter * Math.cos((direction * Math.PI) / 180.0);

  const capW1 = Math.sqrt(
    1.0 -
      SQUARED_ECCENTRICITY *
        Math.pow(Math.sin((location.latitude * Math.PI) / 180.0), 2)
  );
  const capM1 =
    (SEMI_MAJOR_AXIS * (1.0 - SQUARED_ECCENTRICITY)) / Math.pow(capW1, 3.0);

  const latDiff1 = moveMeridian / capM1;
  const midLat = location.latitude + (latDiff1 * 180.0) / Math.PI / 2.0;

  const capW2 = Math.sqrt(
    1.0 -
      SQUARED_ECCENTRICITY * Math.pow(Math.sin((midLat * Math.PI) / 180.0), 2)
  );
  const capM2 =
    (SEMI_MAJOR_AXIS * (1.0 - SQUARED_ECCENTRICITY)) / Math.pow(capW2, 3.0);
  const capN2 = SEMI_MAJOR_AXIS / capW2;

  const latDiff2 = moveMeridian / capM2;
  const lngDiff = moveParallel / capN2 / Math.cos((midLat * Math.PI) / 180.0);

  const endLat = location.latitude + (latDiff2 * 180.0) / Math.PI;
  let endLng = location.longitude + (lngDiff * 180.0) / Math.PI;
  if (endLng < -180.0) {
    endLng += 360.0;
  } else if (endLng > 180.0) {
    endLng -= 360.0;
  }

  return new Location(endLat, endLng);
};
